module.exports = __webpack_public_path__ + "img/issue-icon10.b93d97e.png";